import { render, staticRenderFns } from "./TransactionItemsEdit.vue?vue&type=template&id=018d58a7&"
import script from "./TransactionItemsEdit.vue?vue&type=script&lang=js&"
export * from "./TransactionItemsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports